import React from 'react';
import { useChannelLabel } from '../context/ChannelNumberingContext';
import './ClusterStatisticsWindow.css';

export const formatMetric = (value, digits = 2) => (
  value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value))
    ? Number(value).toFixed(digits) : 'N/A'
);

const ClusterStatisticsWindow = ({ selectedClusters, clusterStats }) => {
  const labelChannel = useChannelLabel();
  // Filter stats for selected clusters
  const selectedStats = selectedClusters.map(clusterId => {
    const stats = clusterStats[clusterId];
    return stats ? { clusterId, ...stats } : null;
  }).filter(Boolean);

  return (
    <div className="cluster-statistics-window">
      <div className="cluster-stats-content">
        {selectedStats.length > 0 ? (
          selectedStats.map((stats, index) => (
            <div key={stats.clusterId} className="cluster-stat-panel">
              <div className="cluster-stat-title">
                Cluster #{stats.clusterId}:
              </div>
              <div className="cluster-stat-items">
                <div className="stat-item">
                  <span className="stat-label">ISI violation rate =</span>
                  <span className="stat-value">{formatMetric(stats.isiViolationRate, 3)}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Number of spikes =</span>
                  <span className="stat-value">{stats.numSpikes || 0}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Peak Channel =</span>
                  <span className="stat-value">{labelChannel(stats.peakChannel) ?? 'N/A'}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Firing rate =</span>
                  <span className="stat-value">{formatMetric(stats.firingRateHz) === 'N/A' ? 'N/A' : `${formatMetric(stats.firingRateHz)} Hz`}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Mean amplitude =</span>
                  <span className="stat-value">{formatMetric(stats.meanAmplitude)}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-cluster-selected">
            <p>Select clusters to view statistics</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClusterStatisticsWindow;
